module.exports = __webpack_public_path__ + "static/media/After - A@2x.04738b23.jpg";